import { inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '../utils/date.utils';

/** Date and time with seconds; app `LOCALE_ID` (e.g. en-AU); 12-hour clock (see `formatDate` in date.utils). */
@Pipe({
  name: 'crowdctrlFormatDate',
  standalone: true,
})
export class CrowdctrlFormatDatePipe implements PipeTransform {
  private readonly localeId = inject(LOCALE_ID);

  transform(value: Date | string | undefined | null): string {
    return formatDate(value, this.localeId);
  }
}
